/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Monthly_HighlightInputs */

const en_plan_monthly_highlight = /** @type {(inputs: Plan_Monthly_HighlightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stay flexible with monthly billing`)
};

const es_plan_monthly_highlight = /** @type {(inputs: Plan_Monthly_HighlightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mantén la flexibilidad con facturación mensual`)
};

/**
* | output |
* | --- |
* | "Stay flexible with monthly billing" |
*
* @param {Plan_Monthly_HighlightInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const plan_monthly_highlight = /** @type {((inputs?: Plan_Monthly_HighlightInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Monthly_HighlightInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_plan_monthly_highlight(inputs)
	return en_plan_monthly_highlight(inputs)
});